export default {
  'Choose File': 'Elegir el archivo',
  'Please paste a URL': 'Pega una URL',
  'Loading': 'Cargando',
  'Analyzing': 'Analizando',
  'Try a sample': 'Una prueba',
  'Sorry, error occurs when analyzing the URL.': 'Lo sentimos, se produce un error al analizar la URL.',
  'Upload a photo': 'Subir una foto',
  "Drag and drop files to the upload box.": 'Arrastra y suelta archivos al cuadro de carga.',
  'Please select the proper position with portrait.': 'Recorta una parte adecuada de la cara.',
  'downloading': 'descargando',
}